import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { AnimatedSection, fadeUp } from "@/components/motion";
import { logError } from "@/lib/logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InsightsSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`)
      .then((r) => setPosts(r.data.slice(0, 3)))
      .catch((err) => logError("Failed to load blog posts", err));
  }, []);

  if (posts.length === 0) return null;

  return (
    <AnimatedSection id="insights" className="py-24 lg:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div variants={fadeUp} className="mb-16">
          <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">Blog</p>
          <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground mb-4">
            Insights from the Industry
          </h2>
          <p className="text-base font-sans text-muted-foreground">
            Exploring textiles, trends, and global markets.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8" data-testid="blog-cards">
          {posts.map((post) => (
            <motion.div key={post.id} variants={fadeUp}>
              <Link to={`/blog/${post.slug || post.id}`} className="group block">
                {post.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden mb-4">
                    <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <p className="text-xs font-sans uppercase tracking-[0.15em] text-[#C5A059] mb-2">{post.category}</p>
                <h3 className="font-serif text-xl text-foreground group-hover:text-[#C5A059] transition-colors duration-200 mb-2">{post.title}</h3>
                <p className="text-sm font-sans text-muted-foreground line-clamp-2">{post.excerpt}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
};
